  <div class="step-preview">
    <div class="step-preview-buttons">
      <div class="step-preview-buttons-fr">
        <button  class="button-icon size-m primary-button" 
          [disabled]="!this.contractStep?.target_key" 
          (click)="viewDocumentInDialog()">
          <mat-icon svgIcon="file-search-fill"> </mat-icon>
          <span>
            {{'CONTRACTS.CARD.VIEW'|translate}}
          </span>
        </button>
      </div>
      <div class="step-preview-buttons-sr">
        <button  
          class="button-icon size-m primary-button"
          [disabled]="
            contractData?.rights?.isCurrentMemberCanAddTargetsAfter === false || 
            (this.contractData?.contract?.contract.status === 'verified' && contractStep?.target?.target_key)" 
          (click)="addDocument()">
          <mat-icon [svgIcon]="contractStep?.target? 'edit-2-fill' : 'add-circle-fill' "> </mat-icon>
          <span>
            {{(contractStep?.target? 'CONTRACTS.CARD.EDIT' : 'CONTRACTS.CARD.ADD')|translate}}
          </span>
        </button>
        <button  class="button-icon size-m secondary-button"
          [disabled]="contractData?.rights?.isContractBlockedForEdit === true">
          <mat-icon class="base-icon" svgIcon="refresh-fill" style="width: 20px;"> </mat-icon>
          <span>
            {{'CONTRACTS.CARD.CLEAR'|translate}}
          </span>
        </button>
      </div>
<!--             <div class="step-preview-buttons-fr">
        <button  class="wide-button button-icon primary-light clone" (click)="deleteStep()">
          <div  class="action-icon contract-icon-delete light-icon step-preview-buttons-fr"></div>
          <span>
            {{'CONTRACTS.CARD.DELETE'|translate}}
          </span>
        </button>
      </div> -->
    </div>
    <div class="step-preview-parties" *ngIf="contractAvatarsService?.contractAvatarMap">
      <div class="step-preview-parties-signed" *ngIf="singedMembers?.length">
        <div class="step-preview-parties-title">{{'CONTRACTS.CARD.SIGNED'| translate}}</div>
        <div class="step-preview-parties-signed-users" >
          <app-contract-avatar *ngFor="let guid of singedMembers"
            [avatarSize]="'42px'"
            [userGuid]="guid" 
            [checkedState]="true">
          </app-contract-avatar>
        </div> 
      </div>
      <div class="step-preview-parties-not_signed" *ngIf="notSingedMembers?.length">
        <div class="step-preview-parties-title">{{'CONTRACTS.CARD.NOT_SIGNED'| translate}}</div>
        <div class="step-preview-parties-not_signed-users" >
          <app-contract-avatar *ngFor="let guid of notSingedMembers"
            [avatarSize]="'42px'"
            [userGuid]="guid" 
            [checkedState]="false">
          </app-contract-avatar>
        </div>
      </div>
    </div>
  </div>
